import { render, staticRenderFns } from "./StagePresenter.vue?vue&type=template&id=3df46ed0&"
import script from "./StagePresenter.vue?vue&type=script&lang=js&"
export * from "./StagePresenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports